import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import uuid from 'uuid';
// import CollapseImg from '../../../images/up-arrow_78-14-40.png';
// import ExpandImg from '../../../images/down-arrow_78-14-40.png';

class CategorySubCatgDropdownList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: [],
      selectedCategoriesId: [],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.categories, nextProps.categories)) {
      this.setState({ selectedCategoriesId: [] });
    }
  }

  onToggle = category => {
    let updatedCategories = this.state.expanded;
    if (this.state.expanded.includes(category)) {
      updatedCategories = updatedCategories.filter(cat => cat !== category);
    } else {
      this.state.expanded.push(category);
    }
    this.setState(() => ({ expanded: updatedCategories }));
  }

  onSelectCategory = categoryId => {
    let updatedCategoriesId = this.state.selectedCategoriesId;
    if (this.state.selectedCategoriesId.includes(categoryId)) {
      updatedCategoriesId = updatedCategoriesId.filter(cat => cat !== categoryId);
    } else {
      this.state.selectedCategoriesId.push(categoryId);
    }
    this.setState(() => ({ selectedCategoriesId: updatedCategoriesId }), () => {
      this.props.onSelectCategory(this.state.selectedCategoriesId);
    });
  }

  render() {
    const { categories, uniqueId,
      searchClick, dropdownBlur,
    tagFocus } = this.props;
    const { selectedCategoriesId, expanded } = this.state;
    if (!tagFocus) {
      return <div />;
    }
    return (
      <div
        className="category-filter"
        data-listid={uniqueId}
        onClick={e => {
          searchClick(e);
          dropdownBlur(true);
        }}
      >
        <button
          type="button"
          className="filter-category"
          data-listid={uniqueId}
          onClick={e => {
            searchClick(e);
            dropdownBlur(true);
          }}
        >Narrow Categories <i className="fa fa-filter" aria-hidden="true" />
        </button>
        <div
          className="filter-panel"
          style={{ height: ($('.categorized-smartsearch-dropdown-box').outerHeight() +
          $('.react-tagsinput').outerHeight()) - $('.btn-toolbar').outerHeight() - 1 }}

        >
          {categories.map(item => (
            <div key={uuid()} className="category-wrapper">
              <div
                className="category-filter-item"
                data-listid={uniqueId}
              >
                <button
                  type="button"
                  className="filter-label"
                  data-listid={uniqueId}
                  style={{
                    fontWeight: selectedCategoriesId.includes(item.pathId)
                    ? 'bold' : 'normal' }}
                  disabled={categories.length < 2}
                  title={item.name}
                  onClick={() => this.onSelectCategory(item.pathId)}
                >
                  {categories.length > 1 &&
                    (<input
                      type="checkbox"
                      className="checkbox"
                      name={item}
                      checked={selectedCategoriesId.includes(item.pathId)}
                    />)
                  }
                  <span className={item.type === 'D' ? 'green-label' : ''}>
                    {item.propCodeType ? `IE - ${item.name}` : item.name }</span>
                </button>
                {/* <button
                  className="toggle-arrow"
                  onClick={() => this.onToggle(item)}
                >
                  {this.state.expanded.includes(item) && <img
                    src={ExpandImg}
                    alt={item}
                  /> }
                  {!this.state.expanded.includes(item) && <img
                    src={CollapseImg}
                    alt={item}
                  /> }
                </button> */}
              </div>
              {expanded.includes(item.name) &&
                item.subCategories && (
                <div className="subCategories-wrapper">
                  {item.subCategories.map(subCat => (
                    <div key={uuid()}>
                      <input type="checkbox" name="subCat" /> {subCat}
                    </div>
                  ))}
                </div>
              )
                  // this.renderSubCategories(item.subCategories)
              }
            </div>
        ))}
        </div>
      </div>
    );
  }
}

CategorySubCatgDropdownList.propTypes = {
  onSelectCategory: PropTypes.func,
  categories: PropTypes.instanceOf(Array),
  uniqueId: PropTypes.string,
  searchClick: PropTypes.func,
  dropdownBlur: PropTypes.func,
  tagFocus: PropTypes.bool,
};

export default CategorySubCatgDropdownList;
